import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { Price } from '../price';

function ItemPrices({ item, category }) {
  const classes = useStyles();

  const options = useMemo(() => {
    const optionGroups = item?.option_groups ?? category?.option_groups;
    const result = optionGroups?.reduce(
      (acc, og) => acc.concat(og.options),
      []
    );

    return result;
  }, [category, item]);

  const isOptional = useMemo(() => {
    const optionGroups = item?.option_groups ?? category?.option_groups;
    const result = optionGroups?.reduce(
      (acc, og) => acc && og.required_min === 0,
      true
    );

    return result;
  }, [category, item]);

  return (
    <div className={classes.container}>
      {item?.prices?.map((price, index) => (
        <Price
          key={price?.id}
          data={price}
          index={index}
          options={options}
          item={item}
          category={category}
          isOptionsOptional={options != null && isOptional}
        />
      ))}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignContent: 'center',
    alignSelf: 'stretch',

    marginLeft: layoutDefaults.horizontalMargin,
    marginRight: layoutDefaults.smallHorizontalMargin,

    // border: '1px solid red',
  },
});

export { ItemPrices };
